import { TextError } from "../../errors/TextError/TextError";
import "./NumberInput.css";

interface NumberInputProps {
  name: string;
  label?: string;
  width?: string;
  margin?: string;
  value: number | "";
  action: (e: React.ChangeEvent<HTMLInputElement>) => void;
  textError?: string;
}

export const NumberInput = ({
  name,
  label,
  width,
  margin,
  value,
  action,
  textError,
}: NumberInputProps) => {
  const styles = {
    width: width || "20rem",
    margin: margin || "0",
  };

  return (
    <div className="number-input" style={styles}>
      {label && <label htmlFor={name}>{label}</label>}
      <input
        id={name}
        name={name}
        type="number"
        value={value}
        onChange={action}
        min="0"
      />
      <TextError text={textError} />
    </div>
  );
};
